import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {AdminStats, UsuarioSisnot, UsuarioSisnotUpdateDTO} from '@core/models/usuario-sisnot';

@Injectable({providedIn: 'root'})
export class AdminService {
  private http = inject(HttpClient);
  private baseUri = environment.api.uri.concat('admin');

  listarUsuarios(): Observable<UsuarioSisnot[]> {
    return this.http.get<UsuarioSisnot[]>(`${this.baseUri}/usuarios`);
  }

  atualizarUsuario(id: number, dto: UsuarioSisnotUpdateDTO): Observable<UsuarioSisnot> {
    return this.http.put<UsuarioSisnot>(`${this.baseUri}/usuarios/${id}`, dto);
  }

  getStats(): Observable<AdminStats> {
    return this.http.get<AdminStats>(`${this.baseUri}/stats`);
  }
}
